import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'adddecimal',
})
export class AdddecimalPipe implements PipeTransform {
  transform(value: number): any {
    if (isNaN(value) === false && value !== 0) {
      const explodedString = value.toString().split('.');
      if (explodedString.length > 1) {
        return value;
      }
      return `${value.toString()}.0`;
    }
    return '0';
  }
}



// WEBPACK FOOTER //
// ./src/app/adddecimal.pipe.ts